import { render, staticRenderFns } from "./HkiaraceEventCategoryAdd.vue?vue&type=template&id=72573974&scoped=true"
import script from "./HkiaraceEventCategoryAdd.vue?vue&type=script&lang=js"
export * from "./HkiaraceEventCategoryAdd.vue?vue&type=script&lang=js"
import style0 from "./HkiaraceEventCategoryAdd.vue?vue&type=style&index=0&id=72573974&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72573974",
  null
  
)

export default component.exports